import { createSelector, createFeatureSelector, MemoizedSelector } from '@ngrx/store'
import { State } from "../reducers/widget-configs"
import { RuleSet, Rule} from "ngx-angular-query-builder";
import { WidgetConfiguration } from "../models/widget-configuration";
import { widgetConfigAdapter } from "../reducers/widget-configs";

export const selectWidgetConfigState = createFeatureSelector<State>('widgetConfig');

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = widgetConfigAdapter.getSelectors(selectWidgetConfigState);

export const selectEntityByWidgetConfigId = (widgetConfigId: number) => createSelector(selectEntities, (entities) => entities[widgetConfigId]);

export function selectLoading() {
  return createSelector(
    [selectWidgetConfigState],
    (state: State) => {
      return state.loading;
    }
  );
}

export function getSysAdminFilterStrings(widgetConfigId: number) {
  return createSelector(
    [selectEntityByWidgetConfigId(widgetConfigId)],
    (widgetConfiguration: WidgetConfiguration) => {
      if (widgetConfiguration && widgetConfiguration.filter && widgetConfiguration.filter.rules && widgetConfiguration.filter.rules.length > 0) {
        let result: string[] = [];
        widgetConfiguration.filter.rules.forEach(x => {
          if (!(x as RuleSet).rules) {
            const rule = x as Rule;
            let condition: string = '';
            if (result.length > 0) {
              condition = `${widgetConfiguration.filter.condition} `;
            }
            result.push(`${condition}${rule.field} ${rule.operator} ${rule.value}`);
          }
        });
        return result;
      }
      return undefined;
    }
  );
}

export function getSysAdminFilters(widgetConfigId: number): MemoizedSelector<object, Rule[]> {
  return createSelector(
    [selectEntityByWidgetConfigId(widgetConfigId)],
    (widgetConfiguration: WidgetConfiguration) => {
      if (widgetConfiguration && widgetConfiguration.filter &&
          widgetConfiguration.filter.rules && widgetConfiguration.filter.rules.length > 0) {
        const result: Rule[] = [];
        widgetConfiguration.filter.rules.forEach(x => {
          if (!(x as RuleSet).rules) {
            const rule = x as Rule;
            result.push(rule);
          }
        });
        return result;
      }
      return undefined;
    }
  );
}
